import { render, staticRenderFns } from "./TeacherCommunication2Page.vue?vue&type=template&id=323f2268&"
import script from "./TeacherCommunication2Page.vue?vue&type=script&lang=ts&"
export * from "./TeacherCommunication2Page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports